<div class="ocd-shell" [class.ocd-shell--expanded]="isExpanded">

  <!-- ===== ACENTO + CABEÇALHO (mesma estrutura do card de Compras) ===== -->
  <div class="ocd-accent" [style.background]="etapaAtual?.color"></div>

  <div class="ocd-header">
    <span class="ocd-card-id">{{ card.id }}</span>
    <span class="ocd-dot"></span>
    <span class="ocd-stage-icon-lg" [style.background]="etapaAtual?.tint"
      [style.border-color]="etapaAtual?.color" [style.color]="etapaAtual?.color">
      <mat-icon class="material-symbols-outlined">{{ etapaAtual?.icon }}</mat-icon>
    </span>
    <div>
      <div class="ocd-stage-name">{{ etapaAtual?.name }}</div>
      <div class="ocd-stage-step">Etapa {{ indiceEtapaAtual + 1 }} de {{ stages.length }}</div>
    </div>

    <span class="ocd-head-spacer"></span>

    <button mat-flat-button type="button" class="btn-primary" (click)="abrirFormularioTimeline('acao')">
      <mat-icon class="material-symbols-outlined">add</mat-icon>
      Incluir ação
    </button>

    <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
      Ações
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #acoesMenu="matMenu">
      <button mat-menu-item (click)="abrirFormularioTimeline('email')">
        <mat-icon class="material-symbols-outlined">mail</mat-icon>
        <span>enviar e-mail</span>
      </button>
      @if (podeAlterar) {
        <button mat-menu-item (click)="abrirFormularioTimeline('anotacao')">
          <mat-icon class="material-symbols-outlined">sticky_note_2</mat-icon>
          <span>anotação</span>
        </button>
      }
      <button mat-menu-item (click)="abrirPainel('tags')">
        <mat-icon class="material-symbols-outlined">label</mat-icon>
        <span>tags</span>
      </button>
      <button mat-menu-item (click)="abrirPainel('outros')">
        <mat-icon class="material-symbols-outlined">forward</mat-icon>
        <span>outros assuntos</span>
      </button>

      <mat-divider></mat-divider>

      <!-- O span carrega o tooltip: item desabilitado não dispara eventos de mouse. -->
      <span [matTooltip]="motivoCriarDocumentoBloqueado ?? ''" matTooltipPosition="left">
        <button mat-menu-item [disabled]="!!motivoCriarDocumentoBloqueado" (click)="criarOrcamento()">
          <mat-icon class="material-symbols-outlined">request_quote</mat-icon>
          <span>Criar orçamento</span>
        </button>
      </span>
      <span [matTooltip]="motivoCriarDocumentoBloqueado ?? ''" matTooltipPosition="left">
        <button mat-menu-item [disabled]="!!motivoCriarDocumentoBloqueado" (click)="criarPedido()">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
          <span>Criar pedido</span>
        </button>
      </span>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="excluirAssunto()">
        <mat-icon class="material-symbols-outlined text-danger">delete</mat-icon>
        <span>excluir assunto</span>
      </button>
    </mat-menu>

    <button mat-icon-button type="button" class="ocd-head-icon" (click)="toggleExpanded()"
      [matTooltip]="isExpanded ? 'Recolher' : 'Expandir'">
      <mat-icon class="material-symbols-outlined">
        {{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}
      </mat-icon>
    </button>
    <button mat-icon-button type="button" class="ocd-head-icon" (click)="fecharFicha()" matTooltip="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>

  <!-- ===== CORPO — 2 colunas (estrutura do protótipo) ===== -->
  <div class="ocd-body">

    <!-- ======= COLUNA ESQUERDA ======= -->
    <div class="ocd-col-left">

      @if (tituloEditando) {
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Título do assunto</mat-label>
          <input matInput [(ngModel)]="tituloDraft" maxlength="120" (keydown.enter)="salvarTitulo()" />
        </mat-form-field>
        <div class="ocd-form-acoes">
          <button mat-button class="btn-secondary" (click)="cancelarTitulo()">Cancelar</button>
          <button mat-flat-button class="btn-primary" (click)="salvarTitulo()">Salvar</button>
        </div>
      } @else {
        <h2 class="ocd-title">
          <button mat-icon-button type="button" class="ocd-title-fav"
            [class.ocd-title-fav--on]="card.isFavorito"
            [disabled]="isFavoritando"
            [attr.aria-pressed]="card.isFavorito"
            [attr.aria-label]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
            [matTooltip]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
            (click)="alternarFavorito()">
            <mat-icon class="material-symbols-outlined" [class.ocd-icon-filled]="card.isFavorito">star</mat-icon>
          </button>
          {{ card.titulo }}
          <button mat-icon-button type="button" class="ocd-title-edit" (click)="iniciarEdicaoTitulo()"
            matTooltip="Editar assunto">
            <mat-icon class="material-symbols-outlined">edit</mat-icon>
          </button>
        </h2>
      }

      <div class="ocd-card-meta">Criado por {{ criadoPorNome }} em {{ dataCriacao | date:'dd/MM/yyyy HH:mm' }}</div>

      <div class="ocd-chips">
        @if (painel) {
          <button type="button" class="ocd-chip" (click)="fecharPainel()">
            <mat-icon class="material-symbols-outlined">arrow_back</mat-icon> Voltar
          </button>
        }
        <span class="ocd-chip ocd-chip--static">
          <mat-icon class="material-symbols-outlined">apartment</mat-icon>{{ card.cliente }}
        </span>
        @if (card.contato) {
          <span class="ocd-chip ocd-chip--static">
            <mat-icon class="material-symbols-outlined">person</mat-icon>{{ card.contato }}
          </span>
        }
        <button type="button" class="ocd-chip" [class.ocd-chip--active]="painel === 'tags'"
          (click)="abrirPainel('tags')">
          <mat-icon class="material-symbols-outlined">label</mat-icon> Tags
          <span class="ocd-chip-badge">{{ card.tags.length }}</span>
        </button>
        <button type="button" class="ocd-chip" [class.ocd-chip--active]="painel === 'anexos'"
          (click)="abrirPainel('anexos')">
          <mat-icon class="material-symbols-outlined">attach_file</mat-icon> Anexos
          <span class="ocd-chip-badge">{{ anexos.length }}</span>
        </button>
        <button type="button" class="ocd-chip" [class.ocd-chip--active]="painel === 'comentarios'"
          (click)="abrirPainel('comentarios')">
          <mat-icon class="material-symbols-outlined">forum</mat-icon> Comentários
          <span class="ocd-chip-badge">{{ comentarios.length }}</span>
        </button>
      </div>

      <!-- Anexos, Comentários e Tags substituem o conteúdo da coluna, como no card de
           Compras: o painel abre aqui do lado, não sobre a ficha. -->
      @if (painel === 'anexos') {
        <app-file-dropzone
          [uploading]="enviandoAnexo"
          [multiple]="false"
          [accept]="tiposArquivoAceitos"
          hint="PDF, XLSX, DOCX, TXT, CSV, imagens · até 10 MB"
          (filesSelected)="arquivosSoltos($event)">
        </app-file-dropzone>

        <div class="section-title">
          <mat-icon class="material-symbols-outlined">attach_file</mat-icon>
          <span>Arquivos do card</span>
          <span class="status-badge badge-cinza">{{ anexos.length }}</span>
        </div>

        @for (anexo of anexos; track anexo.idOportunidadeAnexo) {
          <div class="ocd-anx-file">
            <span class="ocd-anx-ico">
              <mat-icon class="material-symbols-outlined">description</mat-icon>
            </span>
            <div class="ocd-anx-info">
              <div class="ocd-anx-name" [matTooltip]="anexo.nomeArquivo || ''">{{ anexo.nomeArquivo }}</div>
              <div class="ocd-anx-meta">
                @if (autorDoComentario(anexo.idUsuario); as autor) {
                  <span class="ocd-avatar ocd-anx-avatar" [style.background]="autor.color">{{ autor.initials }}</span>
                }
                <span class="ocd-anx-meta-text">
                  @if (autorDoComentario(anexo.idUsuario); as autor) { {{ autor.name }} · }{{ dataCurta(anexo.datetimeInclusao) }}
                  · <span class="ocd-anx-size">{{ tamanhoLegivel(anexo.tamanhoBytes) }}</span>
                </span>
              </div>
            </div>
            <div class="ocd-anx-actions">
              <button type="button" class="ocd-anx-act" matTooltip="Baixar" (click)="baixarAnexo(anexo)">
                <mat-icon class="material-symbols-outlined">download</mat-icon>
              </button>
              <button type="button" class="ocd-anx-act" matTooltip="Remover" (click)="excluirAnexo(anexo)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
          </div>
        } @empty {
          <p class="ocd-vazio">Nenhum anexo.</p>
        }

      } @else if (painel === 'comentarios') {
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">forum</mat-icon>
          <span>Comentários</span>
          <span class="status-badge badge-cinza">{{ comentarios.length }}</span>
        </div>

        @for (comentario of comentarios; track comentario.idOportunidadeComentario) {
          <div class="ocd-comment-card">
            <span class="ocd-avatar"
              [style.background]="autorDoComentario(comentario.idUsuario)?.color || '#9AA0A6'">
              {{ autorDoComentario(comentario.idUsuario)?.initials || '--' }}
            </span>
            <div class="ocd-comment-body">
              <div class="ocd-comment-head">
                <b>{{ autorDoComentario(comentario.idUsuario)?.name || 'Usuário' }}</b>
                <span>· {{ dataCurta(comentario.datetimeInclusao) }}</span>
                @if (comentario.datetimeAlteracao) {
                  <span>(editado)</span>
                }
                <span class="ocd-head-spacer"></span>
                <button type="button" class="ocd-anx-act" matTooltip="Editar"
                  (click)="iniciarEdicaoComentario(comentario)">
                  <mat-icon class="material-symbols-outlined">edit</mat-icon>
                </button>
                <button type="button" class="ocd-anx-act" matTooltip="Excluir"
                  (click)="excluirComentario(comentario)">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>

              @if (comentarioEmEdicao === comentario.idOportunidadeComentario) {
                <div class="ocd-cmt-composer">
                  <textarea class="ocd-cmt-textarea" rows="2" [(ngModel)]="comentarioDraft"></textarea>
                  <div class="ocd-cmt-actions">
                    <span class="ocd-cmt-hint"></span>
                    <button mat-button class="btn-secondary"
                      (click)="cancelarEdicaoComentario()">Cancelar</button>
                    <button mat-flat-button class="btn-primary" [disabled]="!comentarioDraft.trim()"
                      (click)="salvarEdicaoComentario(comentario)">Salvar</button>
                  </div>
                </div>
              } @else {
                <div class="ocd-comment-text">{{ comentario.texto }}</div>
              }
            </div>
          </div>
        } @empty {
          <p class="ocd-vazio">Nenhum comentário.</p>
        }

        <!-- Composer. Sem @menções: o CRM não tem a tabela de menção, então prometer o @ na
             dica seria oferecer o que não existe. -->
        <div class="ocd-cmt-composer">
          <textarea class="ocd-cmt-textarea" rows="3"
            placeholder="Escreva um comentário…"
            [(ngModel)]="comentarioTexto"
            (keydown.control.enter)="enviarComentario()"
            (keydown.meta.enter)="enviarComentario()"></textarea>
          <div class="ocd-cmt-actions">
            <span class="ocd-cmt-hint">Ctrl+Enter para enviar</span>
            <button mat-flat-button type="button" class="btn-primary"
              [disabled]="!comentarioTexto.trim()" (click)="enviarComentario()">Comentar</button>
          </div>
        </div>

      } @else if (painel === 'tags') {
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">label</mat-icon>
          <span>Tags</span>
        </div>
        @if (data.tagsDisponiveis.length === 0) {
          <!-- Sem tag cadastrada não há o que selecionar: diz onde cadastrar e não oferece Salvar. -->
          <p class="ocd-vazio">Nenhuma tag de CRM cadastrada. Cadastre em Configurações › Vendas › Tags de CRM.</p>
          <div class="ocd-painel-acoes">
            <button mat-stroked-button class="btn-secondary" (click)="fecharPainel()">Voltar</button>
          </div>
        } @else {
          <p class="section-sub-title">
            Selecione uma ou mais categorias cadastradas para classificar esta oportunidade.
          </p>
          <!-- Mesmo seletor das tags do documento de venda: dropdown múltiplo e as escolhidas como selos. -->
          <app-select-pesquisavel
            label="Tags"
            [control]="tagsControl"
            [offlineList]="data.tagsDisponiveis"
            idField="idTagCrm"
            nameField="descricao"
            corField="cor"
            [multiple]="true"
            [showBadges]="true"
            placeholder="Selecione...">
          </app-select-pesquisavel>
          <div class="ocd-painel-acoes">
            <button mat-button class="btn-secondary" (click)="fecharPainel()">Cancelar</button>
            <button mat-flat-button class="btn-primary" (click)="salvarTags()">Salvar</button>
          </div>
        }
      } @else if (painel === 'outros') {
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">forward</mat-icon>
          <span>Outros assuntos com este cliente</span>
        </div>
        @if (carregandoOutrosAssuntos) {
          <app-loading-box height="52" margin="0 0 8px 0"></app-loading-box>
          <app-loading-box height="52" margin="0 0 8px 0"></app-loading-box>
        } @else if (outrosAssuntos.length === 0) {
          <p class="ocd-vazio">Nenhum outro assunto para {{ card.cliente }}.</p>
        } @else {
          @for (assunto of outrosAssuntos; track assunto.idOportunidade) {
            <button type="button" class="ocd-outro" (click)="abrirOutroAssunto(assunto.idOportunidade)">
              <span class="ocd-outro-codigo">#{{ assunto.codigo }}</span>
              <span class="ocd-outro-info">
                <span class="ocd-outro-titulo">{{ assunto.titulo }}</span>
                <span class="ocd-outro-etapa">
                  {{ assunto.etapa }}@if (assunto.arquivado) { · arquivado }
                </span>
              </span>
              <mat-icon class="material-symbols-outlined ocd-outro-seta">chevron_right</mat-icon>
            </button>
          }
        }
        <div class="ocd-painel-acoes">
          <button mat-stroked-button class="btn-secondary" (click)="fecharPainel()">Voltar</button>
        </div>
      } @else if (painel === 'historico') {
        <!-- Detalhe do diff de auditoria do item selecionado no Histórico — mesmo visual do
             painel "Detalhes da alteração" do card de Compras. -->
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">history</mat-icon>
          <span>Detalhes da alteração</span>
        </div>

        @if (historicoSelecionado) {
          <div class="ocd-hist-detail-meta">
            @if (autorDoComentario(historicoSelecionado.idUsuario ?? -1); as autor) {
              <span class="ocd-avatar ocd-avatar--xs" [style.background]="autor.color">{{ autor.initials }}</span>
            }
            <span class="ocd-hist-usuario">{{ historicoSelecionado.quemNome }}</span>
            <span class="ocd-hist-data">· {{ historicoSelecionado.quando | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="ocd-hist-detail-titulo">{{ historicoSelecionado.titulo }}</div>
          @if (historicoSelecionado.descricao) {
            <div class="ocd-hist-detail-descricao">{{ historicoSelecionado.descricao }}</div>
          }

          <div class="ocd-hist-detail-list">
            @for (ch of historicoSelecionado.alteracoes; track $index) {
              <div class="ocd-chg">
                <span class="ocd-chg-field">
                  @if (ch.item) { <span class="ocd-chg-item">{{ ch.item }}</span> · }{{ ch.label }}
                </span>
                <span class="ocd-chg-vals">
                  @if (ch.acao === 'adicionado') {
                    <span class="ocd-chg-new">{{ ch.para }}</span>
                  } @else if (ch.acao === 'removido') {
                    <span class="ocd-chg-old">{{ ch.de }}</span>
                  } @else if (ch.de || ch.para) {
                    <span class="ocd-chg-old">{{ ch.de }}</span>
                    <mat-icon class="material-symbols-outlined ocd-chg-arrow">arrow_forward</mat-icon>
                    <span class="ocd-chg-new">{{ ch.para }}</span>
                  } @else {
                    <span class="ocd-chg-msg">alterado</span>
                  }
                </span>
              </div>
            }
          </div>
        }

        <div class="ocd-painel-acoes">
          <button mat-stroked-button class="btn-secondary" (click)="fecharPainel()">Voltar</button>
        </div>
      } @else {

        <div class="row g-3">
          <div class="col-md-6">
            <!-- O span carrega o tooltip: campo desabilitado não dispara eventos de mouse. -->
            <span class="d-block" [matTooltip]="motivoStatusSemPermissao ?? ''"
              [matTooltipDisabled]="!motivoStatusSemPermissao">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Status do cliente</mat-label>
                <mat-select [ngModel]="statusCliente" (ngModelChange)="alterarStatus($event)"
                  [disabled]="!!motivoStatusSemPermissao">
                  @for (status of statusOpcoes; track status.chave) {
                    <mat-option [value]="status.chave">{{ status.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </span>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Prioridade</mat-label>
              <mat-select [ngModel]="card.prioridade" (ngModelChange)="alterarPrioridade($event)">
                @for (prio of prioridades; track prio.chave) {
                  <mat-option [value]="prio.chave">{{ prio.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <app-select-pesquisavel
              [control]="vendedorControl"
              [offlineList]="opcoesVendedor"
              [preloadedOptions]="opcoesVendedor"
              [idField]="'idVendedor'"
              [nameField]="'nome'"
              [label]="'Vendedor responsável'"
              [disabled]="consultandoOrcamentosEmAberto || salvandoVendedor || !!trocaVendedor"
              (selectionChange)="onVendedorSelecionado($event)"
              subscriptSizing="dynamic">
            </app-select-pesquisavel>

            <!-- RN-12: os orçamentos em aberto acompanham a troca de vendedor só com "Sim". -->
            @if (trocaVendedor) {
              <div class="ocd-troca-vendedor" role="alertdialog" aria-label="Orçamentos em aberto">
                <p class="ocd-troca-vendedor-texto">{{ textoTrocaVendedor }}</p>
                <p class="ocd-troca-vendedor-nota">Pedidos não mudam de vendedor.</p>
                <div class="ocd-troca-vendedor-acoes">
                  <button mat-button type="button" class="btn-secondary" [disabled]="salvandoVendedor"
                    (click)="cancelarTrocaVendedor()">Cancelar</button>
                  <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
                    [class.btn-loading]="salvandoVendedor && respostaTrocaVendedor === false" [disabled]="salvandoVendedor"
                    [attr.aria-label]="salvandoVendedor && respostaTrocaVendedor === false ? 'Salvando' : 'Não'"
                    (click)="responderTrocaVendedor(false)">
                    Não
                    @if (salvandoVendedor && respostaTrocaVendedor === false) { <mat-spinner diameter="20"></mat-spinner> }
                  </button>
                  <button #botaoSimTrocaVendedor mat-flat-button type="button" class="btn-primary btn-spinner"
                    [class.btn-loading]="salvandoVendedor && respostaTrocaVendedor === true" [disabled]="salvandoVendedor"
                    [attr.aria-label]="salvandoVendedor && respostaTrocaVendedor === true ? 'Salvando' : 'Sim'"
                    (click)="responderTrocaVendedor(true)">
                    Sim
                    @if (salvandoVendedor && respostaTrocaVendedor === true) { <mat-spinner diameter="20"></mat-spinner> }
                  </button>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Etapas já percorridas, em leitura (CA-18); a etapa atual fica na aba "etapa atual". -->
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">description</mat-icon>
          <span>Etapas anteriores</span>
        </div>

        @if (gruposAnteriores.length === 0) {
          <p class="ocd-sem-campo">Nenhuma etapa anterior.</p>
        } @else {
          <div class="ocd-grupos">
          @for (grupo of gruposAnteriores; track grupo.stage.key) {
            <div class="ocd-grupo">
              <div class="ocd-grupo-head">
                <span class="ocd-grupo-icone" [style.background]="grupo.stage.tint"
                  [style.border-color]="grupo.stage.color" [style.color]="grupo.stage.color">
                  <mat-icon class="material-symbols-outlined">{{ grupo.stage.icon }}</mat-icon>
                </span>
                <span class="ocd-grupo-nome">{{ grupo.stage.name }}</span>
                @if (!grupo.stage.isFinal) {
                  <span class="status-badge badge-cinza ocd-grupo-badge">Concluída</span>
                }
              </div>

              <div class="row g-3">
                @if (grupo.isInicial) {
                  <!-- Campos nativos da oportunidade (não vêm de campo_definicao). -->
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Cliente</span>
                      <span class="ocd-campo-ro-valor">{{ card.cliente || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Contato</span>
                      <span class="ocd-campo-ro-valor">{{ card.contato || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Origem do lead</span>
                      <span class="ocd-campo-ro-valor">{{ origemNome(card.idOrigemLead) || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Canal</span>
                      <span class="ocd-campo-ro-valor">{{ canalNome(card.idCanalContato) || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">{{ valorPorDocumento ? 'Valor da oportunidade' : 'Valor estimado' }}</span>
                      <span class="ocd-campo-ro-valor">{{ valorLabel() }}</span>
                      @if (valorPorDocumento) {
                        <span class="ocd-campo-ro-origem">{{ origemValor }}</span>
                      }
                    </div>
                  </div>
                }
                @if (grupo.stage.isFinal) {
                  <!-- Resultado, motivo e observações finais do encerramento, gravados na oportunidade. -->
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Resultado</span>
                      <span class="ocd-campo-ro-valor">{{ card.resultado || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Motivo</span>
                      <span class="ocd-campo-ro-valor">{{ card.motivo || '—' }}</span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">Observações finais</span>
                      <span class="ocd-campo-ro-valor">{{ card.observacoesFinais || '—' }}</span>
                    </div>
                  </div>
                }
                @for (campo of grupo.campos; track campo.idCampoDefinicao) {
                  <div [class]="campo.controle === 'textoLongo' ? 'col-12' : 'col-md-6'">
                    <div class="ocd-campo-ro">
                      <span class="ocd-uplabel">{{ campo.nome }}</span>
                      <span class="ocd-campo-ro-valor">{{ (campo.controle === 'numero' ? (valorCampoNumero(campo) | abnt: 'quantidade' : 2) : valorCampoLeitura(campo)) || '—' }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          </div>
        }

        <!-- Ações: lançar e editar abrem no topo da linha do tempo (CA-19, CA-24). -->
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">push_pin</mat-icon>
          <span>Ações</span>
          <div class="section-title-actions ms-auto">
            @if (!temAcaoPendente) {
              <button mat-button class="btn-section" type="button" (click)="abrirFormularioTimeline('acao')">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Adicionar
              </button>
            }
          </div>
        </div>

        @if (temAcaoPendente) {
          <div class="ocd-acao-card">
            <div class="ocd-acao-card-top">
              <mat-icon class="material-symbols-outlined ocd-acao-icone">schedule</mat-icon>
              <span class="status-badge badge-cinza" [class.ocd-acao-badge--vencida]="acaoBadge.vencida">
                {{ acaoBadge.label }}
              </span>
              <span class="ocd-head-spacer"></span>
              <button mat-icon-button type="button" class="ocd-acao-editar" matTooltip="Editar ação"
                aria-label="Editar ação" (click)="abrirFormularioTimeline('acao')">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
              </button>
            </div>
            <p class="ocd-acao-texto">{{ card.proximaAcao }}</p>
            <div class="ocd-acao-card-rodape">
              @if (responsavelAcao) {
                <span class="ocd-avatar ocd-avatar--sm" [style.background]="responsavelAcao.color">
                  {{ responsavelAcao.initials }}
                </span>
                <span class="ocd-acao-resp">{{ responsavelAcao.name }}</span>
              }
              <span class="ocd-head-spacer"></span>
              <button mat-stroked-button type="button" class="ocd-btn-concluir" (click)="concluirAcao()">
                <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                concluir
              </button>
            </div>
          </div>
        } @else {
          <p class="ocd-vazio">Nenhuma ação pendente.</p>
        }

        <!-- Histórico: só eventos do sistema, sem editar nem excluir (CA-21). -->
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">history</mat-icon>
          <span>Histórico</span>
          @if (!carregandoHistorico) {
            <span class="status-badge badge-cinza">{{ historicoSistema.length }}</span>
          }
        </div>

        @if (carregandoHistorico) {
          <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
          <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
        } @else {
          <app-timeline-historico
            [itens]="historicoSistema"
            [exibirFiltros]="true"
            [exibirFiltroPeriodoUsuario]="true"
            [permiteDetalhes]="true"
            (detalhar)="abrirDetalheHistorico($event)"></app-timeline-historico>
        }

      }

    </div>

    <!-- ======= COLUNA DIREITA ======= -->
    <div class="ocd-col-right">
      <div class="ocd-tabs">
        <button class="ocd-tab" [class.ocd-tab--active]="aba === 'etapa'"
          (click)="selecionarAba('etapa')">etapa atual</button>
        <button class="ocd-tab" [class.ocd-tab--active]="aba === 'timeline'"
          (click)="selecionarAba('timeline')">linha do tempo</button>
        <button class="ocd-tab" [class.ocd-tab--active]="aba === 'vendas'"
          (click)="selecionarAba('vendas')">vendas</button>
        <button class="ocd-tab" [class.ocd-tab--active]="aba === 'financeiro'"
          (click)="selecionarAba('financeiro')">financeiro</button>
        <button class="ocd-tab" [class.ocd-tab--active]="aba === 'servicos'"
          (click)="selecionarAba('servicos')">serviços</button>
      </div>

      <div class="ocd-col-right-body" #areaPrincipal>
        @if (aba === 'etapa') {
          @if (grupoAtual; as grupo) {
            @if (grupo.stage.descricao) {
              <div class="ocd-instruction" [style.border-left-color]="grupo.stage.color"
                [style.background]="grupo.stage.tint">
                <mat-icon class="material-symbols-outlined ocd-instruction-icon"
                  [style.color]="grupo.stage.color">lightbulb</mat-icon>
                <div>
                  <div class="ocd-instruction-title">O que fazer nesta etapa</div>
                  <div class="ocd-instruction-text">{{ grupo.stage.descricao }}</div>
                </div>
              </div>
            }

            @if (grupo.isInicial || grupo.campos.length) {
              <div class="ocd-grade-campos">
                @if (grupo.isInicial) {
                  <!-- Campos nativos da oportunidade na Prospecção; o vendedor fica na lateral. -->
                  <!-- Com documento de Vendas vinculado o cliente não muda (o orquestrador também recusa). -->
                  <div class="ocd-grade-item" [matTooltip]="clienteBloqueado ? mensagemClienteBloqueado : ''">
                    <app-select-pesquisavel
                      [control]="clienteControl"
                      [apiUrl]="urlPessoa"
                      [extraParams]="filtroCliente"
                      [idField]="'id'"
                      [nameField]="'descricao'"
                      [label]="'Cliente'"
                      [disabled]="clienteBloqueado"
                      (selectionChange)="onClienteSelecionado($event)"
                      subscriptSizing="dynamic">
                    </app-select-pesquisavel>
                  </div>
                  <app-select-pesquisavel
                    [control]="contatoControl"
                    [offlineList]="contatos"
                    [preloadedOptions]="contatos"
                    [idField]="'id'"
                    [nameField]="'descricao'"
                    [label]="'Contato'"
                    [isOptional]="true"
                    [disabled]="!clienteControl.value || carregandoContatos"
                    [hint]="semContatos ? 'Este cliente não tem contatos cadastrados.' : ''"
                    (selectionChange)="onContatoSelecionado($event)"
                    subscriptSizing="dynamic">
                  </app-select-pesquisavel>
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Origem do lead</mat-label>
                    <mat-select [ngModel]="idOrigemLead" (ngModelChange)="alterarOrigemLead($event)" required>
                      @for (origem of origens; track origem.id) {
                        <mat-option [value]="origem.id">{{ origem.descricao }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Canal</mat-label>
                    <mat-select [ngModel]="idCanalContato" (ngModelChange)="alterarCanalContato($event)">
                      <mat-option [value]="null">Não informado</mat-option>
                      @for (canal of canais; track canal.id) {
                        <mat-option [value]="canal.id">{{ canal.descricao }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (valorPorDocumento) {
                    <!-- Valor calculado pelo documento de Vendas que o define: sem edição na ficha. -->
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Valor da oportunidade</mat-label>
                      <input matInput currencyMask [ngModel]="card.valor" disabled
                        [options]="mascaraMoeda" />
                      <mat-hint>{{ origemValor }}</mat-hint>
                    </mat-form-field>
                  } @else {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Valor estimado</mat-label>
                      <input matInput currencyMask [ngModel]="valorEstimado"
                        (ngModelChange)="definirValorEstimadoNativo($event)"
                        [options]="mascaraMoeda" />
                    </mat-form-field>
                  }
                }

                @for (campo of grupo.campos; track campo.idCampoDefinicao) {
                  <div class="ocd-grade-item" [class.ocd-grade-item--linha]="campo.controle === 'textoLongo'">
                    @switch (campo.controle) {
                      @case ('textoLongo') {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          <textarea matInput rows="3" [ngModel]="valorCampo(campo)"
                            (ngModelChange)="definirValorCampo(campo, $event)"
                            [required]="campo.obrigatorio"></textarea>
                        </mat-form-field>
                      }
                      @case ('data') {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          <input matInput [matDatepicker]="dp" [ngModel]="valorCampoData(campo)"
                            (ngModelChange)="definirValorCampoData(campo, $event)"
                            [required]="campo.obrigatorio" />
                          <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                          <mat-datepicker #dp></mat-datepicker>
                        </mat-form-field>
                      }
                      @case ('numero') {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          <input matInput type="text" inputmode="numeric" [currencyMask]="mascaraNumero"
                            [ngModel]="valorCampoNumero(campo)"
                            (ngModelChange)="definirValorCampoNumero(campo, $event)"
                            [required]="campo.obrigatorio" />
                        </mat-form-field>
                      }
                      @case ('selecao') {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          <mat-select [ngModel]="valorCampoSelecao(campo)"
                            (ngModelChange)="definirValorCampoSelecao(campo, $event)"
                            [required]="campo.obrigatorio">
                            <mat-option [value]="null">—</mat-option>
                            @for (opcao of campo.opcoes; track opcao.idCampoDefinicaoOpcao) {
                              <mat-option [value]="opcao.idCampoDefinicaoOpcao">{{ opcao.descricao }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @case ('selecaoMultipla') {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          <mat-select multiple [ngModel]="valorCampoSelecaoMultipla(campo)"
                            (ngModelChange)="definirValorCampoSelecaoMultipla(campo, $event)"
                            [required]="campo.obrigatorio">
                            @for (opcao of campo.opcoes; track opcao.idCampoDefinicaoOpcao) {
                              <mat-option [value]="opcao.idCampoDefinicaoOpcao">{{ opcao.descricao }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @case ('booleano') {
                        <div class="ocd-campo-toggle">
                          <mat-slide-toggle class="app-toggle-compact" color="primary"
                            [checked]="campoLigado(campo)"
                            (change)="alternarCampoBooleano(campo, $event.checked)">
                          </mat-slide-toggle>
                          <span>{{ campo.nome }}</span>
                        </div>
                      }
                      @case ('anexo') {
                        <div class="ocd-campo-anexo">
                          <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
                          <span>{{ campo.nome }}</span>
                          <span class="ocd-badge-espec">a especificar</span>
                        </div>
                      }
                      @default {
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                          <mat-label>{{ campo.nome }}</mat-label>
                          @if (campo.prefixo) {
                            <span matTextPrefix>{{ campo.prefixo }}&nbsp;</span>
                          }
                          <input matInput [ngModel]="valorCampo(campo)"
                            (ngModelChange)="definirValorCampo(campo, $event)"
                            [required]="campo.obrigatorio" />
                          @if (campo.sufixo) {
                            <span matTextSuffix>{{ campo.sufixo }}</span>
                          }
                        </mat-form-field>
                      }
                    }
                  </div>
                }
              </div>
            } @else {
              <p class="ocd-vazio">Nenhum campo configurado para esta etapa.</p>
            }
          } @else {
            <p class="ocd-vazio">Oportunidade encerrada. Os dados das etapas ficam na lateral.</p>
          }
        } @else if (aba === 'vendas') {
          @if (!podeVisualizarVendas) {
            <!-- Sem Visualizar do Processo de Venda a aba não consulta Vendas e diz a permissão que falta (CA-43). -->
            <app-alert-card type="info" icon="lock" title="Sem permissão para ver os documentos de Vendas">
              Para ver e criar orçamentos e pedidos aqui, peça ao administrador a permissão Visualizar do Processo de Venda.
            </app-alert-card>
          } @else {
            <div class="ocd-vendas-acoes">
              <span [matTooltip]="motivoCriarDocumentoBloqueado ?? ''">
                <button mat-stroked-button type="button" class="btn-secondary"
                  [disabled]="!!motivoCriarDocumentoBloqueado" (click)="criarPedido()">
                  <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                  Criar pedido
                </button>
              </span>
              <span [matTooltip]="motivoCriarDocumentoBloqueado ?? ''">
                <button mat-flat-button type="button" class="btn-primary"
                  [disabled]="!!motivoCriarDocumentoBloqueado" (click)="criarOrcamento()">
                  <mat-icon class="material-symbols-outlined">add</mat-icon>
                  Criar orçamento
                </button>
              </span>
            </div>

            <div class="section-title">
              <mat-icon class="material-symbols-outlined">description</mat-icon>
              <span>Documentos desta oportunidade</span>
            </div>

            @if (carregandoDocumentos && !documentosCarregados) {
              <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
              <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
            } @else if (!documentos.length) {
              <p class="ocd-vazio">Nenhum orçamento ainda. Use "Criar orçamento" para criar o primeiro.</p>
            } @else {
              <div class="table-container desktop-view">
                <!-- Linhas por predicado: documento, "Sem acesso ao documento" (RN-20) e a confirmação do desvínculo. -->
                <table mat-table [dataSource]="documentos" multiTemplateDataRows class="w-100">
                  <ng-container matColumnDef="numero">
                    <th mat-header-cell *matHeaderCellDef>Número</th>
                    <td mat-cell *matCellDef="let documento">
                      <a class="ocd-doc-link" [href]="urlDocumento(documento.idVenda)" target="_blank" rel="noopener">{{ documento.numero }}</a>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let documento">{{ nomeTipoDocumento(documento) }}</td>
                  </ng-container>

                  <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef>Data</th>
                    <td mat-cell *matCellDef="let documento">{{ documento.dataEmissao | date: 'dd/MM/yyyy' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="vendedor">
                    <th mat-header-cell *matHeaderCellDef>Vendedor</th>
                    <td mat-cell *matCellDef="let documento">{{ nomeVendedorDocumento(documento.idVendedor) }}</td>
                  </ng-container>

                  <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                    <td mat-cell *matCellDef="let documento" class="text-end">
                      <span class="ocd-doc-valor">
                        @if (documento.isDefineValor) {
                          <mat-icon class="material-symbols-outlined" matTooltip="Define o valor da oportunidade."
                            aria-label="Define o valor da oportunidade.">check_circle</mat-icon>
                        }
                        {{ documento.valorTotal | abnt: 'preco' : 2 }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="situacao">
                    <th mat-header-cell *matHeaderCellDef>Situação</th>
                    <td mat-cell *matCellDef="let documento">
                      <span class="ocd-doc-situacao">
                        @let cor = corDaEtapa(documento.idKanbanCor);
                        <span class="status-badge" [style.background]="cor.fundo" [style.color]="cor.conteudo"
                          [matTooltip]="documento.nomeEtapaKanban">
                          {{ documento.nomeEtapaKanban }}
                        </span>
                        @if (documento.isVencido) {
                          <span class="status-badge badge-vermelho"
                            matTooltip="Validade expirada. Continua contando no valor.">Vencido</span>
                        }
                      </span>
                      @if (documento.dataValidade) {
                        <div class="ocd-doc-validade">Validade {{ documento.dataValidade | date: 'dd/MM/yyyy' }}</div>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                    <td mat-cell *matCellDef="let documento" class="text-center w-actions">
                      <button mat-icon-button type="button" aria-label="Ações do documento" [matMenuTriggerFor]="menuDocumento">
                        <span class="material-symbols-outlined">more_horiz</span>
                      </button>
                      <mat-menu #menuDocumento="matMenu">
                        <button mat-menu-item (click)="abrirDocumento(documento)">
                          <span class="material-symbols-outlined">view_kanban</span>
                          <span>Abrir no Processo de Venda</span>
                        </button>
                        <!-- O span carrega o tooltip: item desabilitado não dispara eventos de mouse. -->
                        <span [matTooltip]="motivoVinculoSemPermissao" matTooltipPosition="left">
                          <button mat-menu-item [disabled]="!!motivoVinculoSemPermissao || idVendaProcessando != null"
                            [attr.aria-label]="motivoVinculoSemPermissao || null" (click)="pedirDesvinculo(documento)">
                            <span class="material-symbols-outlined">link_off</span>
                            <span>Desvincular</span>
                          </button>
                        </span>
                      </mat-menu>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="semAcesso">
                    <td mat-cell *matCellDef="let documento" [attr.colspan]="colunasDocumentos.length">
                      <span class="ocd-doc-sem-acesso">
                        <mat-icon class="material-symbols-outlined">lock</mat-icon>
                        Sem acesso ao documento
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="confirmacao">
                    <td mat-cell *matCellDef="let documento" [attr.colspan]="colunasDocumentos.length">
                      <div class="ocd-tl-confirmacao ocd-tl-confirmacao--neutra">
                        <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                        <span class="ocd-tl-confirmacao-texto">{{ textoConfirmacaoDesvinculo(documento) }}</span>
                        <button mat-stroked-button type="button" class="btn-secondary"
                          [disabled]="idVendaProcessando === documento.idVenda" (click)="cancelarDesvinculo()">Cancelar</button>
                        <button mat-flat-button type="button" class="btn-primary btn-spinner"
                          [class.btn-loading]="idVendaProcessando === documento.idVenda"
                          [disabled]="idVendaProcessando != null"
                          [attr.aria-label]="idVendaProcessando === documento.idVenda ? 'Desvinculando' : 'Desvincular'"
                          (click)="desvincularDocumento(documento)">
                          Desvincular
                          @if (idVendaProcessando === documento.idVenda) { <mat-spinner diameter="20"></mat-spinner> }
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="colunasDocumentos"></tr>
                  <tr mat-row *matRowDef="let documento; columns: colunasDocumentos; when: isDocumentoComAcesso"></tr>
                  <tr mat-row *matRowDef="let documento; columns: ['semAcesso']; when: isDocumentoSemAcesso"></tr>
                  <tr mat-row *matRowDef="let documento; columns: ['confirmacao']; when: isConfirmandoDesvinculo"></tr>
                </table>
              </div>

              <div class="mobile-view">
                @for (documento of documentos; track documento.idVenda) {
                  <div class="card-mobile">
                    @if (documento.isSemAcesso) {
                      <div class="card-header-mobile">
                        <span class="ocd-doc-sem-acesso">
                          <mat-icon class="material-symbols-outlined">lock</mat-icon>
                          Sem acesso ao documento
                        </span>
                      </div>
                    } @else {
                      <div class="card-header-mobile">
                        <a class="ocd-doc-link" [href]="urlDocumento(documento.idVenda)" target="_blank" rel="noopener">
                          {{ nomeTipoDocumento(documento) }} nº {{ documento.numero }}
                        </a>
                        <button mat-icon-button type="button" aria-label="Ações do documento" [matMenuTriggerFor]="menuDocumentoMobile">
                          <span class="material-symbols-outlined">more_horiz</span>
                        </button>
                        <mat-menu #menuDocumentoMobile="matMenu">
                          <button mat-menu-item (click)="abrirDocumento(documento)">
                            <span class="material-symbols-outlined">view_kanban</span>
                            <span>Abrir no Processo de Venda</span>
                          </button>
                          <!-- O span carrega o tooltip: item desabilitado não dispara eventos de mouse. -->
                          <span [matTooltip]="motivoVinculoSemPermissao" matTooltipPosition="left">
                            <button mat-menu-item [disabled]="!!motivoVinculoSemPermissao || idVendaProcessando != null"
                              [attr.aria-label]="motivoVinculoSemPermissao || null" (click)="pedirDesvinculo(documento)">
                              <span class="material-symbols-outlined">link_off</span>
                              <span>Desvincular</span>
                            </button>
                          </span>
                        </mat-menu>
                      </div>
                      <div class="card-body-mobile">
                        <div><strong>Data:</strong> {{ documento.dataEmissao | date: 'dd/MM/yyyy' }}</div>
                        <div><strong>Vendedor:</strong> {{ nomeVendedorDocumento(documento.idVendedor) }}</div>
                        <div>
                          <strong>Valor:</strong> {{ documento.valorTotal | abnt: 'preco' : 2 }}
                          @if (documento.isDefineValor) {
                            <span class="status-badge badge-cinza">Define o valor da oportunidade</span>
                          }
                        </div>
                        <div>
                          <strong>Situação:</strong>
                          @let corMobile = corDaEtapa(documento.idKanbanCor);
                          <span class="status-badge" [style.background]="corMobile.fundo" [style.color]="corMobile.conteudo">{{ documento.nomeEtapaKanban }}</span>
                          @if (documento.isVencido) {
                            <span class="status-badge badge-vermelho">Vencido</span>
                          }
                        </div>
                        @if (documento.dataValidade) {
                          <div><strong>Validade:</strong> {{ documento.dataValidade | date: 'dd/MM/yyyy' }}</div>
                        }
                        @if (idVendaConfirmandoDesvinculo === documento.idVenda) {
                          <div class="ocd-tl-confirmacao ocd-tl-confirmacao--neutra">
                            <span class="ocd-tl-confirmacao-texto">{{ textoConfirmacaoDesvinculo(documento) }}</span>
                            <button mat-stroked-button type="button" class="btn-secondary"
                              [disabled]="idVendaProcessando === documento.idVenda" (click)="cancelarDesvinculo()">Cancelar</button>
                            <button mat-flat-button type="button" class="btn-primary btn-spinner"
                              [class.btn-loading]="idVendaProcessando === documento.idVenda"
                              [disabled]="idVendaProcessando != null"
                              [attr.aria-label]="idVendaProcessando === documento.idVenda ? 'Desvinculando' : 'Desvincular'"
                              (click)="desvincularDocumento(documento)">
                              Desvincular
                              @if (idVendaProcessando === documento.idVenda) { <mat-spinner diameter="20"></mat-spinner> }
                            </button>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <!-- Histórico do cliente: três blocos, cada um com o próprio erro, sem derrubar os outros. -->
            <div class="section-title ocd-vendas-secao">
              <mat-icon class="material-symbols-outlined">person_search</mat-icon>
              <span>Histórico do cliente</span>
            </div>

            @if (carregandoHistoricoCliente && !historicoCliente) {
              <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
              <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
            } @else {
              @if (historicoCliente; as hc) {
              <div class="sub-section-title">Últimos cinco pedidos</div>
              @if (hc.erroPedidos) {
                <app-alert-card type="warning">{{ hc.erroPedidos }}</app-alert-card>
              } @else if (!hc.pedidos.length) {
                <p class="ocd-vazio">Nenhum pedido do cliente.</p>
              } @else {
                <div class="table-container desktop-view">
                  <table mat-table [dataSource]="hc.pedidos" class="w-100">
                    <ng-container matColumnDef="numero">
                      <th mat-header-cell *matHeaderCellDef>Número</th>
                      <td mat-cell *matCellDef="let pedido">
                        <a class="ocd-doc-link" [href]="urlDocumento(pedido.idVenda)" target="_blank" rel="noopener">{{ pedido.numero }}</a>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="data">
                      <th mat-header-cell *matHeaderCellDef>Data</th>
                      <td mat-cell *matCellDef="let pedido">{{ pedido.dataEmissao | date: 'dd/MM/yyyy' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="vendedor">
                      <th mat-header-cell *matHeaderCellDef>Vendedor</th>
                      <td mat-cell *matCellDef="let pedido">{{ nomeVendedorDocumento(pedido.idVendedor) }}</td>
                    </ng-container>

                    <ng-container matColumnDef="valor">
                      <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                      <td mat-cell *matCellDef="let pedido" class="text-end">{{ pedido.valorTotal | abnt: 'preco' : 2 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="situacao">
                      <th mat-header-cell *matHeaderCellDef>Situação</th>
                      <td mat-cell *matCellDef="let pedido">
                        @let corPedido = corDaEtapa(pedido.idKanbanCor);
                        <span class="status-badge" [style.background]="corPedido.fundo" [style.color]="corPedido.conteudo"
                          [matTooltip]="pedido.nomeEtapaKanban ?? ''">{{ pedido.nomeEtapaKanban }}</span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="colunasPedidosCliente"></tr>
                    <tr mat-row *matRowDef="let pedido; columns: colunasPedidosCliente"></tr>
                  </table>
                </div>

                <div class="mobile-view">
                  @for (pedido of hc.pedidos; track pedido.idVenda) {
                    <div class="card-mobile">
                      <div class="card-header-mobile">
                        <a class="ocd-doc-link" [href]="urlDocumento(pedido.idVenda)" target="_blank" rel="noopener">Pedido nº {{ pedido.numero }}</a>
                      </div>
                      <div class="card-body-mobile">
                        <div><strong>Data:</strong> {{ pedido.dataEmissao | date: 'dd/MM/yyyy' }}</div>
                        <div><strong>Vendedor:</strong> {{ nomeVendedorDocumento(pedido.idVendedor) }}</div>
                        <div><strong>Valor:</strong> {{ pedido.valorTotal | abnt: 'preco' : 2 }}</div>
                        <div>
                          <strong>Situação:</strong>
                          @let corPedidoMobile = corDaEtapa(pedido.idKanbanCor);
                          <span class="status-badge" [style.background]="corPedidoMobile.fundo" [style.color]="corPedidoMobile.conteudo">{{ pedido.nomeEtapaKanban }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              <div class="sub-section-title ocd-vendas-subsecao">Notas fiscais do cliente</div>
              @if (hc.isNotasFiscaisIndisponiveis) {
                <app-empty-state icon="receipt" title="Notas fiscais indisponíveis"
                  subtitle="Para ver aqui as últimas 5 notas fiscais do cliente, peça ao administrador a permissão Visualizar de Notas fiscais."></app-empty-state>
              } @else if (hc.erroNotasFiscais) {
                <app-alert-card type="warning">{{ hc.erroNotasFiscais }}</app-alert-card>
              } @else if (!hc.notasFiscais.length) {
                <p class="ocd-vazio">Nenhuma nota fiscal do cliente.</p>
              } @else {
                <div class="table-container desktop-view">
                  <table mat-table [dataSource]="hc.notasFiscais" class="w-100">
                    <ng-container matColumnDef="numero">
                      <th mat-header-cell *matHeaderCellDef>Número</th>
                      <td mat-cell *matCellDef="let nota">
                        <a class="ocd-doc-link" [href]="urlNotaFiscal(nota.idNFeSaida)" target="_blank" rel="noopener">{{ nota.numero ?? '—' }}</a>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="data">
                      <th mat-header-cell *matHeaderCellDef>Data</th>
                      <td mat-cell *matCellDef="let nota">{{ nota.dataEmissao | date: 'dd/MM/yyyy' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="valor">
                      <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                      <td mat-cell *matCellDef="let nota" class="text-end">{{ nota.valorTotal | abnt: 'preco' : 2 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="situacao">
                      <th mat-header-cell *matHeaderCellDef>Situação</th>
                      <td mat-cell *matCellDef="let nota">
                        <span [class]="'status-badge ' + classeStatusNotaFiscal(nota)"
                          [matTooltip]="nota.nomeStatusNFeSaida ?? ''">{{ nota.nomeStatusNFeSaida || '—' }}</span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="colunasNotasCliente"></tr>
                    <tr mat-row *matRowDef="let nota; columns: colunasNotasCliente"></tr>
                  </table>
                </div>

                <div class="mobile-view">
                  @for (nota of hc.notasFiscais; track nota.idNFeSaida) {
                    <div class="card-mobile">
                      <div class="card-header-mobile">
                        <a class="ocd-doc-link" [href]="urlNotaFiscal(nota.idNFeSaida)" target="_blank" rel="noopener">Nota fiscal nº {{ nota.numero ?? '—' }}</a>
                      </div>
                      <div class="card-body-mobile">
                        <div><strong>Data:</strong> {{ nota.dataEmissao | date: 'dd/MM/yyyy' }}</div>
                        <div><strong>Valor:</strong> {{ nota.valorTotal | abnt: 'preco' : 2 }}</div>
                        <div>
                          <strong>Situação:</strong>
                          <span [class]="'status-badge ' + classeStatusNotaFiscal(nota)">{{ nota.nomeStatusNFeSaida || '—' }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              <div class="sub-section-title ocd-vendas-subsecao">Outros documentos do cliente</div>
              <p class="ocd-vendas-subtitulo">Orçamentos e pedidos do cliente que não estão vinculados a esta oportunidade.</p>
              @if (hc.erroOutrosDocumentos) {
                <app-alert-card type="warning">{{ hc.erroOutrosDocumentos }}</app-alert-card>
              } @else if (!hc.outrosDocumentos.length) {
                <p class="ocd-vazio">Nenhum outro orçamento ou pedido do cliente.</p>
              } @else {
                <div class="table-container desktop-view">
                  <table mat-table [dataSource]="hc.outrosDocumentos" class="w-100">
                    <ng-container matColumnDef="numero">
                      <th mat-header-cell *matHeaderCellDef>Número</th>
                      <td mat-cell *matCellDef="let outro">
                        <a class="ocd-doc-link" [href]="urlDocumento(outro.idVenda)" target="_blank" rel="noopener">{{ outro.numero }}</a>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="tipo">
                      <th mat-header-cell *matHeaderCellDef>Tipo</th>
                      <td mat-cell *matCellDef="let outro">{{ nomeTipoDocumento(outro) }}</td>
                    </ng-container>

                    <ng-container matColumnDef="data">
                      <th mat-header-cell *matHeaderCellDef>Data</th>
                      <td mat-cell *matCellDef="let outro">{{ outro.dataEmissao | date: 'dd/MM/yyyy' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="vendedor">
                      <th mat-header-cell *matHeaderCellDef>Vendedor</th>
                      <td mat-cell *matCellDef="let outro">{{ nomeVendedorDocumento(outro.idVendedor) }}</td>
                    </ng-container>

                    <ng-container matColumnDef="valor">
                      <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                      <td mat-cell *matCellDef="let outro" class="text-end">{{ outro.valorTotal | abnt: 'preco' : 2 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="situacao">
                      <th mat-header-cell *matHeaderCellDef>Situação</th>
                      <td mat-cell *matCellDef="let outro">
                        @let corOutro = corDaEtapa(outro.idKanbanCor);
                        <span class="status-badge" [style.background]="corOutro.fundo" [style.color]="corOutro.conteudo"
                          [matTooltip]="outro.nomeEtapaKanban">{{ outro.nomeEtapaKanban }}</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acoes">
                      <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                      <td mat-cell *matCellDef="let outro" class="text-center w-actions">
                        <!-- Vincular roda pelo menu: o spinner fica no lugar do ícone de ações da linha. -->
                        <button mat-icon-button type="button" class="btn-spinner"
                          [class.btn-loading]="idVendaProcessando === outro.idVenda"
                          [disabled]="idVendaProcessando === outro.idVenda"
                          [attr.aria-label]="idVendaProcessando === outro.idVenda ? 'Vinculando' : 'Ações do documento'"
                          [matMenuTriggerFor]="menuOutro">
                          <span class="material-symbols-outlined">more_horiz</span>
                          @if (idVendaProcessando === outro.idVenda) { <mat-spinner diameter="20"></mat-spinner> }
                        </button>
                        <mat-menu #menuOutro="matMenu">
                          <span [matTooltip]="motivoVincularBloqueado" matTooltipPosition="left">
                            <button mat-menu-item [disabled]="!!motivoVincularBloqueado || idVendaProcessando != null"
                              [attr.aria-label]="motivoVincularBloqueado || null" (click)="vincularDocumento(outro)">
                              <span class="material-symbols-outlined">add_link</span>
                              <span>Vincular a esta oportunidade</span>
                            </button>
                          </span>
                        </mat-menu>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="colunasOutrosDocumentos"></tr>
                    <tr mat-row *matRowDef="let outro; columns: colunasOutrosDocumentos"></tr>
                  </table>
                </div>

                <div class="mobile-view">
                  @for (outro of hc.outrosDocumentos; track outro.idVenda) {
                    <div class="card-mobile">
                      <div class="card-header-mobile">
                        <a class="ocd-doc-link" [href]="urlDocumento(outro.idVenda)" target="_blank" rel="noopener">
                          {{ nomeTipoDocumento(outro) }} nº {{ outro.numero }}
                        </a>
                        <!-- Vincular roda pelo menu: o spinner fica no lugar do ícone de ações da linha. -->
                        <button mat-icon-button type="button" class="btn-spinner"
                          [class.btn-loading]="idVendaProcessando === outro.idVenda"
                          [disabled]="idVendaProcessando === outro.idVenda"
                          [attr.aria-label]="idVendaProcessando === outro.idVenda ? 'Vinculando' : 'Ações do documento'"
                          [matMenuTriggerFor]="menuOutroMobile">
                          <span class="material-symbols-outlined">more_horiz</span>
                          @if (idVendaProcessando === outro.idVenda) { <mat-spinner diameter="20"></mat-spinner> }
                        </button>
                        <mat-menu #menuOutroMobile="matMenu">
                          <span [matTooltip]="motivoVincularBloqueado" matTooltipPosition="left">
                            <button mat-menu-item [disabled]="!!motivoVincularBloqueado || idVendaProcessando != null"
                              [attr.aria-label]="motivoVincularBloqueado || null" (click)="vincularDocumento(outro)">
                              <span class="material-symbols-outlined">add_link</span>
                              <span>Vincular a esta oportunidade</span>
                            </button>
                          </span>
                        </mat-menu>
                      </div>
                      <div class="card-body-mobile">
                        <div><strong>Data:</strong> {{ outro.dataEmissao | date: 'dd/MM/yyyy' }}</div>
                        <div><strong>Vendedor:</strong> {{ nomeVendedorDocumento(outro.idVendedor) }}</div>
                        <div><strong>Valor:</strong> {{ outro.valorTotal | abnt: 'preco' : 2 }}</div>
                        <div>
                          <strong>Situação:</strong>
                          @let corOutroMobile = corDaEtapa(outro.idKanbanCor);
                          <span class="status-badge" [style.background]="corOutroMobile.fundo" [style.color]="corOutroMobile.conteudo">{{ outro.nomeEtapaKanban }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              }
            }
          }
        } @else if (aba === 'financeiro') {
          @if (!podeVisualizarFinanceiro) {
            <!-- Sem Visualizar de Contas a Receber a aba não consulta Finanças e diz a permissão que falta. -->
            <app-alert-card type="info" icon="lock" title="Sem permissão para ver o financeiro do cliente">
              Para consultar os títulos a receber, peça ao administrador a permissão Visualizar de Contas a Receber (Finanças).
            </app-alert-card>
          } @else if (carregandoFinanceiro && !financeiro) {
            <app-loading-box height="72" margin="0 0 12px 0"></app-loading-box>
            <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
            <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
          } @else if (erroFinanceiro) {
            <!-- Falha da requisição inteira: só esta aba mostra o aviso; as outras continuam funcionando. Na nova
                 tentativa o skeleton toma o lugar do aviso. -->
            <app-alert-card type="warning">
              {{ erroFinanceiro }}
              <div alertActions>
                <button mat-stroked-button type="button" class="btn-secondary" (click)="tentarFinanceiroNovamente()">
                  <mat-icon class="material-symbols-outlined">refresh</mat-icon>
                  Tentar novamente
                </button>
              </div>
            </app-alert-card>
          } @else if (financeiro; as fin) {
            <!-- Resumo: totais calculados em Finanças só sobre os não pagos, não mudam com o filtro. -->
            <div class="ocd-fin-resumo">
              <div class="ocd-fin-resumo-card">
                <span class="ocd-fin-resumo-label">Total em aberto</span>
                @if (fin.erroTitulos) {
                  <span class="ocd-fin-resumo-valor" [matTooltip]="fin.erroTitulos"
                    [attr.aria-label]="fin.erroTitulos">Indisponível</span>
                } @else {
                  <span class="ocd-fin-resumo-valor">{{ fin.totalEmAberto | abnt: 'preco' : 2 }}</span>
                }
              </div>
              <div class="ocd-fin-resumo-card">
                <span class="ocd-fin-resumo-label">Total vencido</span>
                @if (fin.erroTitulos) {
                  <span class="ocd-fin-resumo-valor" [matTooltip]="fin.erroTitulos"
                    [attr.aria-label]="fin.erroTitulos">Indisponível</span>
                } @else {
                  <span class="ocd-fin-resumo-valor">{{ fin.totalVencido | abnt: 'preco' : 2 }}</span>
                }
              </div>
              <div class="ocd-fin-resumo-card">
                <span class="ocd-fin-resumo-label">Limite de crédito disponível</span>
                @if (fin.erroLimite) {
                  <span class="ocd-fin-resumo-valor" [matTooltip]="fin.erroLimite"
                    [attr.aria-label]="fin.erroLimite">Indisponível</span>
                } @else if (fin.limiteCredito == null) {
                  <span class="ocd-fin-resumo-valor ocd-fin-resumo-valor--sem">Sem limite definido</span>
                } @else {
                  <span class="ocd-fin-resumo-valor">{{ fin.limiteDisponivel | abnt: 'preco' : 2 }}</span>
                }
              </div>
            </div>

            <div class="section-title">
              <mat-icon class="material-symbols-outlined">payments</mat-icon>
              <span>{{ incluirPagosRecentes ? 'Contas em aberto, vencidas e pagas recentes' : 'Contas em aberto e vencidas' }}</span>
              <div class="section-title-actions ms-auto">
                <button mat-stroked-button type="button" class="btn-filter btn-spinner ocd-fin-filtro"
                  [class.btn-loading]="carregandoFinanceiro && acaoFinanceiro === 'pagosRecentes'" [disabled]="carregandoFinanceiro"
                  [attr.aria-pressed]="incluirPagosRecentes" aria-label="Incluir pagos recentes"
                  (click)="alternarPagosRecentes()">
                  <mat-icon class="material-symbols-outlined">{{ incluirPagosRecentes ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  Incluir pagos recentes
                  @if (carregandoFinanceiro && acaoFinanceiro === 'pagosRecentes') { <mat-spinner diameter="20"></mat-spinner> }
                </button>
              </div>
            </div>

            @if (fin.erroTitulos) {
              <app-alert-card type="warning">
                {{ fin.erroTitulos }}
                <div alertActions>
                  <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
                    [class.btn-loading]="carregandoFinanceiro && acaoFinanceiro === 'tentarNovamente'" [disabled]="carregandoFinanceiro"
                    aria-label="Tentar novamente" (click)="tentarFinanceiroNovamente()">
                    <mat-icon class="material-symbols-outlined">refresh</mat-icon>
                    Tentar novamente
                    @if (carregandoFinanceiro && acaoFinanceiro === 'tentarNovamente') { <mat-spinner diameter="20"></mat-spinner> }
                  </button>
                </div>
              </app-alert-card>
            } @else if (!fin.titulos.length) {
              <p class="ocd-vazio">Não há contas em aberto para este cliente.</p>
            } @else {
              <div class="table-container desktop-view">
                <table mat-table [dataSource]="fin.titulos" class="w-100">
                  <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef>Data</th>
                    <td mat-cell *matCellDef="let titulo">{{ titulo.dataEmissao ? (titulo.dataEmissao | date: 'dd/MM/yyyy') : '—' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                    <td mat-cell *matCellDef="let titulo" class="text-end">
                      {{ titulo.valor | abnt: 'preco' : 2 }}
                      @if (titulo.idStatusContasReceber !== statusContasReceber.Recebido && titulo.saldo !== titulo.valor) {
                        <div class="ocd-fin-apoio">Em aberto {{ titulo.saldo | abnt: 'preco' : 2 }}</div>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="vencimento">
                    <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                    <td mat-cell *matCellDef="let titulo">{{ titulo.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="documento">
                    <th mat-header-cell *matHeaderCellDef>Documento</th>
                    <td mat-cell *matCellDef="let titulo">
                      <!-- Título lançado pelo pedido: o número do documento é o número do pedido. -->
                      @if (titulo.idVenda && titulo.numeroDocumento) {
                        Pedido {{ titulo.numeroDocumento }}
                      } @else if (titulo.numeroDocumento) {
                        {{ titulo.numeroDocumento }}
                      } @else {
                        <span class="ocd-fin-apoio">Sem documento</span>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="situacao">
                    <th mat-header-cell *matHeaderCellDef>Situação</th>
                    <td mat-cell *matCellDef="let titulo">
                      <span [class]="'status-badge ' + classeSituacaoTitulo(titulo)" [matTooltip]="situacaoTitulo(titulo)"
                        [attr.aria-label]="situacaoTitulo(titulo)">{{ situacaoTitulo(titulo) }}</span>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="colunasTitulos"></tr>
                  <tr mat-row *matRowDef="let titulo; columns: colunasTitulos"></tr>
                </table>
              </div>

              <div class="mobile-view">
                @for (titulo of fin.titulos; track titulo.idContasReceberParcela) {
                  <div class="card-mobile">
                    <div class="card-header-mobile">
                      @if (titulo.idVenda && titulo.numeroDocumento) {
                        <span>Pedido {{ titulo.numeroDocumento }}</span>
                      } @else if (titulo.numeroDocumento) {
                        <span>{{ titulo.numeroDocumento }}</span>
                      } @else {
                        <span class="ocd-fin-apoio">Sem documento</span>
                      }
                    </div>
                    <div class="card-body-mobile">
                      <div><strong>Data:</strong> {{ titulo.dataEmissao ? (titulo.dataEmissao | date: 'dd/MM/yyyy') : '—' }}</div>
                      <div>
                        <strong>Valor:</strong> {{ titulo.valor | abnt: 'preco' : 2 }}
                        @if (titulo.idStatusContasReceber !== statusContasReceber.Recebido && titulo.saldo !== titulo.valor) {
                          <div class="ocd-fin-apoio">Em aberto {{ titulo.saldo | abnt: 'preco' : 2 }}</div>
                        }
                      </div>
                      <div><strong>Vencimento:</strong> {{ titulo.dataVencimento | date: 'dd/MM/yyyy' }}</div>
                      <div>
                        <strong>Situação:</strong>
                        <span [class]="'status-badge ' + classeSituacaoTitulo(titulo)">{{ situacaoTitulo(titulo) }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Parcelas previstas dos pedidos vinculados (Vendas); sem Visualizar do Processo de Venda não aparecem. -->
            @if (!fin.isParcelasIndisponiveis) {
              @if (fin.erroParcelas) {
                <div class="ocd-vendas-secao">
                  <app-alert-card type="warning">{{ fin.erroParcelas }}</app-alert-card>
                </div>
              } @else {
                @for (pedido of fin.pedidos; track pedido.idVenda) {
                  <div class="section-title ocd-vendas-secao">
                    <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                    <span>Parcelas do Pedido {{ pedido.numero }}</span>
                  </div>
                  @if (!pedido.pagamentos.length) {
                    <p class="ocd-fin-apoio">Pedido sem parcelas definidas.</p>
                  }
                  @for (pagamento of pedido.pagamentos; track $index) {
                    <p class="ocd-vendas-subtitulo ocd-fin-pagamento">
                      Condição de pagamento: {{ pagamento.nomeCondicaoPagamento ?? pagamento.condicaoPagamentoLivre ?? '—' }}
                      · Forma de recebimento: {{ pagamento.nomeFormaRecebimento ?? '—' }}
                    </p>
                    @if (!pagamento.parcelas.length) {
                      <p class="ocd-fin-apoio">Recebimento sem parcelas definidas.</p>
                    } @else {
                    <div class="table-container">
                      <table mat-table [dataSource]="pagamento.parcelas" class="w-100">
                        <ng-container matColumnDef="parcela">
                          <th mat-header-cell *matHeaderCellDef>Parcela</th>
                          <td mat-cell *matCellDef="let parcela">{{ parcela.numeroParcela }}/{{ pagamento.parcelas.length }}</td>
                        </ng-container>

                        <ng-container matColumnDef="vencimento">
                          <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                          <td mat-cell *matCellDef="let parcela">{{ parcela.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="valor">
                          <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                          <td mat-cell *matCellDef="let parcela" class="text-end">{{ parcela.valor | abnt: 'preco' : 2 }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="colunasParcelasPedido"></tr>
                        <tr mat-row *matRowDef="let parcela; columns: colunasParcelasPedido"></tr>
                      </table>
                    </div>
                    }
                  }
                }
              }
            }

            <p class="ocd-fin-apoio ocd-fin-rodape">Somente consulta. Os títulos vêm de Finanças / Contas a receber.</p>
          }
        } @else if (aba === 'servicos') {
          <div class="ocd-instruction ocd-instruction--espec">
            <mat-icon class="material-symbols-outlined ocd-instruction-icon">schedule</mat-icon>
            <div>
              <div class="ocd-instruction-title">A especificar</div>
              <div class="ocd-instruction-text">
                A rotina de Serviços ainda será especificada — esta aba
                não é desenvolvida nesta entrega.
              </div>
            </div>
          </div>
        } @else {
          <!-- Formulários de lançamento e edição no topo da linha do tempo, um por vez (CA-19, CA-20). -->
          @if (formularioTimeline) {
            <div class="ocd-tl-form">
              <div class="ocd-tl-form-titulo">
                <mat-icon class="material-symbols-outlined">{{ iconeFormularioTimeline }}</mat-icon>
                <span>{{ tituloFormularioTimeline }}</span>
              </div>

              @switch (formularioTimeline) {
                @case ('acao') {
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Descrição da ação</mat-label>
                    <textarea #primeiroCampoTimeline matInput rows="3" maxlength="256" required
                      [(ngModel)]="acaoTexto" placeholder="Ex.: Ligar para confirmar reunião"></textarea>
                    <mat-hint align="end">{{ acaoTexto.length }}/256</mat-hint>
                  </mat-form-field>

                  <mat-checkbox class="ocd-checkbox" [(ngModel)]="acaoComData">Definir data</mat-checkbox>

                  <div class="ocd-tl-form-grade">
                    @if (acaoComData) {
                      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Previsto para</mat-label>
                        <input matInput [matDatepicker]="dpAcao" [(ngModel)]="acaoData" />
                        <mat-datepicker-toggle matIconSuffix [for]="dpAcao"></mat-datepicker-toggle>
                        <mat-datepicker #dpAcao></mat-datepicker>
                      </mat-form-field>
                    }
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Usuário responsável</mat-label>
                      <mat-select [(ngModel)]="acaoResponsavel">
                        @for (pessoa of data.pessoas; track pessoa.idUsuario) {
                          <mat-option [value]="pessoa.idUsuario">{{ pessoa.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="ocd-form-acoes">
                    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="salvandoFormulario"
                      (click)="fecharFormularioTimeline()">Cancelar</button>
                    <span [matTooltip]="'Informe a descrição da ação.'" [matTooltipDisabled]="!!acaoTexto.trim() || salvandoFormulario">
                      <button mat-flat-button type="button" class="btn-primary btn-spinner"
                        [class.btn-loading]="salvandoFormulario"
                        [disabled]="!acaoTexto.trim() || salvandoFormulario"
                        [attr.aria-label]="salvandoFormulario ? 'Salvando' : 'Salvar'" (click)="salvarAcao()">
                        <mat-icon class="material-symbols-outlined">check</mat-icon>
                        Salvar
                        @if (salvandoFormulario) { <mat-spinner diameter="20"></mat-spinner> }
                      </button>
                    </span>
                  </div>
                }
                @case ('email') {
                  @if (semEnderecoEmail) {
                    <app-alert-card type="error" title="Endereço de e-mail não cadastrado">
                      Para enviar o e-mail é necessário que um contato com e-mail válido esteja vinculado ao assunto.
                    </app-alert-card>
                    <div class="ocd-form-acoes">
                      <button mat-stroked-button type="button" class="btn-secondary"
                        (click)="fecharFormularioTimeline()">Voltar</button>
                    </div>
                  } @else {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Para</mat-label>
                      <input #primeiroCampoTimeline matInput required [(ngModel)]="emailPara" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Assunto</mat-label>
                      <input matInput [(ngModel)]="emailAssunto" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Mensagem</mat-label>
                      <textarea matInput rows="6" [(ngModel)]="emailMensagem"
                        placeholder="Escreva a mensagem…"></textarea>
                    </mat-form-field>

                    <div class="ocd-form-acoes">
                      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="salvandoFormulario"
                        (click)="fecharFormularioTimeline()">Cancelar</button>
                      <span [matTooltip]="'Informe o destinatário do e-mail.'" [matTooltipDisabled]="!!emailPara.trim() || salvandoFormulario">
                        <button mat-flat-button type="button" class="btn-primary btn-spinner"
                          [class.btn-loading]="salvandoFormulario"
                          [disabled]="!emailPara.trim() || salvandoFormulario"
                          [attr.aria-label]="salvandoFormulario ? 'Enviando mensagem' : 'Enviar mensagem'"
                          (click)="enviarEmail()">
                          <mat-icon class="material-symbols-outlined">send</mat-icon>
                          Enviar mensagem
                          @if (salvandoFormulario) { <mat-spinner diameter="20"></mat-spinner> }
                        </button>
                      </span>
                    </div>
                  }
                }
                @case ('anotacao') {
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Nota ou observação</mat-label>
                    <textarea #primeiroCampoTimeline matInput rows="5" required
                      [maxlength]="tamanhoMaximoRegistro" [(ngModel)]="anotacaoTexto"
                      placeholder="Escreva a anotação…"></textarea>
                    <mat-hint align="end">{{ anotacaoTexto.length }}/{{ tamanhoMaximoRegistro }}</mat-hint>
                  </mat-form-field>

                  <div class="ocd-form-acoes">
                    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="salvandoFormulario"
                      (click)="fecharFormularioTimeline()">Cancelar</button>
                    <span [matTooltip]="'Informe a nota ou observação.'" [matTooltipDisabled]="!!anotacaoTexto.trim() || salvandoFormulario">
                      <button mat-flat-button type="button" class="btn-primary btn-spinner"
                        [class.btn-loading]="salvandoFormulario"
                        [disabled]="!anotacaoTexto.trim() || salvandoFormulario"
                        [attr.aria-label]="salvandoFormulario ? 'Salvando' : 'Salvar'" (click)="salvarRegistroTimeline()">
                        <mat-icon class="material-symbols-outlined">check</mat-icon>
                        Salvar
                        @if (salvandoFormulario) { <mat-spinner diameter="20"></mat-spinner> }
                      </button>
                    </span>
                  </div>
                }
                @case ('acaoConcluida') {
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Descrição</mat-label>
                    <textarea #primeiroCampoTimeline matInput rows="3" required
                      [maxlength]="tamanhoMaximoRegistro" [(ngModel)]="acaoConcluidaTexto"></textarea>
                    <mat-hint align="end">{{ acaoConcluidaTexto.length }}/{{ tamanhoMaximoRegistro }}</mat-hint>
                  </mat-form-field>

                  <div class="ocd-form-acoes">
                    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="salvandoFormulario"
                      (click)="fecharFormularioTimeline()">Cancelar</button>
                    <span [matTooltip]="'Informe a descrição.'" [matTooltipDisabled]="!!acaoConcluidaTexto.trim() || salvandoFormulario">
                      <button mat-flat-button type="button" class="btn-primary btn-spinner"
                        [class.btn-loading]="salvandoFormulario"
                        [disabled]="!acaoConcluidaTexto.trim() || salvandoFormulario"
                        [attr.aria-label]="salvandoFormulario ? 'Salvando' : 'Salvar'" (click)="salvarRegistroTimeline()">
                        <mat-icon class="material-symbols-outlined">check</mat-icon>
                        Salvar
                        @if (salvandoFormulario) { <mat-spinner diameter="20"></mat-spinner> }
                      </button>
                    </span>
                  </div>
                }
              }
            </div>
          }

          @if (carregandoHistorico) {
            <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
            <app-loading-box height="48" margin="0 0 12px 0"></app-loading-box>
          } @else {
            <!-- Ações, e-mails, anotações e orçamentos (CA-21), com editar e excluir por linha (CA-22), e um registro por
                 documento de Vendas vinculado, montado da aba Vendas (CA-50). -->
            @if (linhasDoTempo.length > 0) {
              @for (linha of linhasDoTempo; track linha.chave) {
                @if (linha.documento; as documento) {
                  <!-- Documento de Vendas vinculado: sem editar nem excluir; abre o documento e desvincula (CA-50). -->
                  <div class="ocd-tl-item">
                    <div class="ocd-tl-data">
                      <div class="ocd-tl-dia">{{ documento.dataEmissao | date: 'dd' }}</div>
                      <div class="ocd-tl-mes">{{ mesAbreviado(documento.dataEmissao) }}</div>
                      <div class="ocd-tl-ano">{{ documento.dataEmissao | date: 'yy' }}</div>
                    </div>

                    <span class="ocd-tl-icone" [style.background]="estiloDocumentoLinhaDoTempo.fundo"
                      [style.color]="estiloDocumentoLinhaDoTempo.cor">
                      <mat-icon class="material-symbols-outlined">{{ iconeDocumento(documento) }}</mat-icon>
                    </span>

                    <div class="ocd-tl-conteudo">
                      <div class="ocd-tl-titulo">{{ nomeDocumento(documento) }}</div>
                      <div class="ocd-tl-descricao">{{ documento.valorTotal | abnt: 'preco' : 2 }} · {{ documento.nomeEtapaKanban }}</div>
                      <div class="ocd-tl-rodape">
                        @if (documento.idVendedor != null) {
                          @let vendedorDocumento = nomeVendedorDocumento(documento.idVendedor);
                          <span class="ocd-tl-avatar" [style.background]="corAvatar(vendedorDocumento)">{{ iniciaisAvatar(vendedorDocumento) }}</span>
                          <span>{{ vendedorDocumento }}</span>
                          <span class="ocd-tl-tipo">· {{ nomeTipoDocumento(documento) }}</span>
                        } @else {
                          <span class="ocd-tl-tipo">{{ nomeTipoDocumento(documento) }}</span>
                        }
                      </div>

                      @if (idVendaConfirmandoDesvinculo === documento.idVenda) {
                        <div class="ocd-tl-confirmacao ocd-tl-confirmacao--neutra">
                          <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                          <span class="ocd-tl-confirmacao-texto">{{ textoConfirmacaoDesvinculo(documento) }}</span>
                          <button mat-stroked-button type="button" class="btn-secondary"
                            [disabled]="idVendaProcessando === documento.idVenda" (click)="cancelarDesvinculo()">Cancelar</button>
                          <button mat-flat-button type="button" class="btn-primary btn-spinner"
                            [class.btn-loading]="idVendaProcessando === documento.idVenda"
                            [disabled]="idVendaProcessando != null"
                            [attr.aria-label]="idVendaProcessando === documento.idVenda ? 'Desvinculando' : 'Desvincular'"
                            (click)="desvincularDocumento(documento)">
                            Desvincular
                            @if (idVendaProcessando === documento.idVenda) { <mat-spinner diameter="20"></mat-spinner> }
                          </button>
                        </div>
                      }
                    </div>

                    @if (idVendaConfirmandoDesvinculo !== documento.idVenda) {
                      <div class="ocd-tl-acoes">
                        <button mat-icon-button type="button" matTooltip="Abrir documento" aria-label="Abrir documento"
                          (click)="abrirDocumento(documento)">
                          <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                        </button>
                        <!-- O span carrega o tooltip: botão desabilitado não dispara eventos de mouse. -->
                        <span [matTooltip]="motivoVinculoSemPermissao ?? 'Desvincular'">
                          <button mat-icon-button type="button"
                            [disabled]="!!motivoVinculoSemPermissao || idVendaProcessando != null"
                            [attr.aria-label]="motivoVinculoSemPermissao ?? 'Desvincular'"
                            (click)="pedirDesvinculo(documento)">
                            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                          </button>
                        </span>
                      </div>
                    }
                  </div>
                } @else {
                @let item = linha.registro!;
                @let estilo = estilosLinhaDoTempo[item.idTipoOcorrenciaOportunidade];
                <div class="ocd-tl-item" [class.ocd-tl-item--editando]="registroEditando === item">
                  <div class="ocd-tl-data">
                    <div class="ocd-tl-dia">{{ item.quando | date: 'dd' }}</div>
                    <div class="ocd-tl-mes">{{ mesAbreviado(item.quando) }}</div>
                    <div class="ocd-tl-ano">{{ item.quando | date: 'yy' }}</div>
                  </div>

                  <span class="ocd-tl-icone" [style.background]="estilo.fundo" [style.color]="estilo.cor">
                    <mat-icon class="material-symbols-outlined">{{ estilo.icone }}</mat-icon>
                  </span>

                  <div class="ocd-tl-conteudo">
                    <div class="ocd-tl-titulo">{{ item.tituloLinhaDoTempo }}</div>
                    @if (item.descricaoLinhaDoTempo) {
                      <div class="ocd-tl-descricao">{{ item.descricaoLinhaDoTempo }}</div>
                    }
                    <div class="ocd-tl-rodape">
                      <span class="ocd-tl-avatar" [style.background]="corAvatar(item.quemNome)">{{ iniciaisAvatar(item.quemNome) }}</span>
                      <span>{{ item.quemNome }}</span>
                      <span class="ocd-tl-tipo">· {{ item.titulo }}</span>
                    </div>

                    @if (registroConfirmandoExclusao === item) {
                      <div class="ocd-tl-confirmacao">
                        <span class="ocd-tl-confirmacao-texto">Excluir este registro da linha do tempo?</span>
                        <button mat-stroked-button type="button" class="btn-secondary"
                          (click)="cancelarExclusaoRegistroTimeline()">Cancelar</button>
                        <button mat-flat-button type="button" class="btn-primary"
                          (click)="excluirRegistroTimeline(item)">Excluir</button>
                      </div>
                    }
                  </div>

                  <!-- Editar segue Alterar e Excluir segue Excluir (as permissões da API); sem nenhuma das duas, sem ícones. -->
                  @if ((podeAlterar || podeExcluirRegistro) && registroEditando !== item && registroConfirmandoExclusao !== item) {
                    <div class="ocd-tl-acoes">
                      <!-- O span carrega o tooltip: botão desabilitado não dispara eventos de mouse. -->
                      <span [matTooltip]="item.podeEditar ? 'Editar registro' : (item.motivoNaoEditavel || '')">
                        <button mat-icon-button type="button"
                          [disabled]="!item.podeEditar || itemExcluindo != null"
                          [attr.aria-label]="item.podeEditar ? 'Editar registro' : (item.motivoNaoEditavel || 'Editar registro')"
                          (click)="editarRegistroTimeline(item)">
                          <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                      </span>
                      <span [matTooltip]="item.podeExcluir ? 'Excluir registro' : (item.motivoNaoExcluivel || '')">
                        <button mat-icon-button type="button" class="btn-spinner"
                          [class.btn-loading]="itemExcluindo === item"
                          [disabled]="!item.podeExcluir || itemExcluindo != null"
                          [attr.aria-label]="itemExcluindo === item ? 'Excluindo registro' : (item.podeExcluir ? 'Excluir registro' : (item.motivoNaoExcluivel || 'Excluir registro'))"
                          (click)="pedirExclusaoRegistroTimeline(item)">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon>
                          @if (itemExcluindo === item) { <mat-spinner diameter="18"></mat-spinner> }
                        </button>
                      </span>
                    </div>
                  }
                </div>
                }
              }
            } @else {
              <app-empty-state icon="history" title="Nenhum registro na linha do tempo."></app-empty-state>
            }
          }
        }
      </div>
    </div>
  </div>

  <!-- ===== PAINÉIS DAS AÇÕES — abrem sobre o corpo, sem novo modal (CA18) ===== -->

  <!-- ===== FAB MOVER CARD (mesma estrutura do card de Compras) ===== -->
  <div class="ocd-move-fab-wrap">
    @if (moverAberto) {
      <div class="ocd-move-backdrop" (click)="moverAberto = false"></div>
      <div class="ocd-move-panel">
        <div class="ocd-move-panel-head">
          <span>Mover card</span>
          <button type="button" class="ocd-move-close" (click)="moverAberto = false" matTooltip="Fechar">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
        <div class="ocd-move-panel-body">
          @if (podeMover) {
            @for (destino of destinosAvancar; track destino.key) {
              <button type="button" class="ocd-mv-btn" (click)="mover(destino)">
                <span class="ocd-mv-ico">
                  <mat-icon class="material-symbols-outlined">{{ destino.icon }}</mat-icon>
                </span>
                <span class="ocd-mv-text">
                  <span class="ocd-mv-kind">Avançar para</span>
                  <span class="ocd-mv-name">{{ destino.name }}</span>
                </span>
                <mat-icon class="material-symbols-outlined ocd-mv-arrow">arrow_forward</mat-icon>
              </button>
            }

            @if (etapasFinais.length === 1) {
              <button type="button" class="ocd-mv-btn ocd-mv-btn--danger"
                (click)="encerrar(etapasFinais[0])">
                <span class="ocd-mv-ico">
                  <mat-icon class="material-symbols-outlined">flag</mat-icon>
                </span>
                <span class="ocd-mv-text">
                  <span class="ocd-mv-kind">Estado especial</span>
                  <span class="ocd-mv-name">Encerrar oportunidade</span>
                </span>
              </button>
            } @else if (etapasFinais.length > 1) {
              <!-- Com mais de um desfecho configurado, o destino é escolha do usuário. -->
              <div class="ocd-mv-section">Encerrar em</div>
              @for (final of etapasFinais; track final.key) {
                <button type="button" class="ocd-mv-btn ocd-mv-btn--danger" (click)="encerrar(final)">
                  <span class="ocd-mv-ico">
                    <mat-icon class="material-symbols-outlined">{{ final.icon }}</mat-icon>
                  </span>
                  <span class="ocd-mv-text">
                    <span class="ocd-mv-kind">Encerrar como</span>
                    <span class="ocd-mv-name">{{ final.name }}</span>
                  </span>
                </button>
              }
            }

            @if (destinosRetornar.length) {
              <div class="ocd-mv-section">Retornar para</div>
              @for (destino of destinosRetornar; track destino.key) {
                <button type="button" class="ocd-mv-back" (click)="mover(destino)">
                  <mat-icon class="material-symbols-outlined ocd-mv-back-arrow">arrow_back</mat-icon>
                  <span class="ocd-mv-back-name">{{ destino.name }}</span>
                  <span class="ocd-mv-back-ico" [style.background]="destino.tint"
                    [style.color]="destino.color">
                    <mat-icon class="material-symbols-outlined">{{ destino.icon }}</mat-icon>
                  </span>
                </button>
              }
            }

            @if (!destinosAvancar.length && !destinosRetornar.length && !etapasFinais.length) {
              <p class="ocd-vazio">Nenhum destino configurado a partir desta etapa.</p>
            }
          } @else {
            <p class="ocd-mv-terminal">Esta é uma etapa final: o card não avança mais.</p>
            <button type="button" class="ocd-mv-btn" (click)="reabrir()">
              <span class="ocd-mv-ico">
                <mat-icon class="material-symbols-outlined">lock_open</mat-icon>
              </span>
              <span class="ocd-mv-text">
                <span class="ocd-mv-kind">Retomar</span>
                <span class="ocd-mv-name">Reabrir oportunidade</span>
              </span>
            </button>
          }
        </div>
      </div>
    }

    <button type="button" class="ocd-move-fab" [class.ocd-move-fab--open]="moverAberto"
      (click)="moverAberto = !moverAberto"
      [matTooltip]="moverAberto ? 'Fechar movimentações' : 'Mover card para outra etapa'">
      <mat-icon class="material-symbols-outlined">{{ moverAberto ? 'close' : 'swap_horiz' }}</mat-icon>
    </button>
  </div>
</div>
